// extracted by mini-css-extract-plugin
module.exports = {"grid":"axis_grid__mBo1g","zero":"axis_zero__M32VL","label":"axis_label__kOU44","line":"axis_line__7UnC1","tick":"axis_tick__P5SMG"};